import {commonActions} from '../../actions/commonActions';
import {warehouseSetList,warehouseGetItem} from '../../actions/WarehouseActions';
import {connect} from 'react-redux';
import List from '../../components/warehouse/WarehouseProductList';
import {API_FETCH} from '../../services/FetchService';
import {list as areaList} from '../../containers/area/AreaListPage';
import {list as userList} from "../user/ListPage";



const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },
    getAreaList : () => {
        return(dispatch(areaList()));
    },
    getUserList: () => {
        return(dispatch(userList()))
    },

});

const getItem = (id) => {
    return (dispatch, getState) => {
        let states = getState();
        API_FETCH.get('warehouse/inventory/'+id).then(list => {
            dispatch(warehouseGetItem(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.warehouse.list,
        common       : state.common,
        initialValues: state.warehouse.getItem,
        areaList     : state.area.areaList,
        userList     : state.user.list,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);
